export const isRoleMatch = function (roleToCheck: any, requiredRole: any) {
  return roleToCheck === requiredRole;
}
